import { Box, Grid, List, ListItem, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { KeyFigures as Props } from '@/types';
import Heading from '../Heading';

const KeyFigures = ({ data, title }: Props) => {
  const { t } = useTranslation('frontoffice');
  return (
    <Box p={[4, 6, 8]} borderRadius="lg" background="white">
      {title && (
        <Heading variant="h5" as="h2" mb="4">
          {title}
        </Heading>
      )}
      {data?.length ? (
        <Grid
          templateColumns="repeat(auto-fit, minmax(200px, 1fr))"
          gap="4"
          as={List}
        >
          {data.map(({ value, name, translationKey }) => (
            <ListItem key={`${value}-${name}`}>
              <Heading
                as="p"
                variant="h2"
                mb="2"
                fontWeight="500"
                color="success.500"
              >
                {value}
              </Heading>
              <Text as="h3">
                {translationKey ? t(translationKey, name) : name}
              </Text>
            </ListItem>
          ))}
        </Grid>
      ) : null}
    </Box>
  );
};

export default KeyFigures;
